import * as React from "react"
import { Link as RouterLink } from "gatsby";
import { Container, Box, Stack, Typography, Link, Divider } from "@mui/material";

const Footer = () => (
  <Box sx={{ backgroundColor: 'accentBackground', py: '30px', fontSize: 13 }}>
    <Container maxWidth="lg">
      <Stack spacing={2} alignItems={{ xs: 'center', sm: 'stretch' }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'center', sm: 'flex-start' }} spacing={2}>
          <Stack direction="row" spacing={2}>
            <Link component={RouterLink} to="/terms">Terms of Use</Link>
            <Divider orientation="vertical" flexItem />
            <Link component={RouterLink} to="/privacy">Privacy Policy</Link>
            <Divider orientation="vertical" flexItem />
            <Link component={RouterLink} to="/payments">Payments</Link>
            <Divider orientation="vertical" flexItem />
            <Link component={RouterLink} to="/contact">Contact</Link>
          </Stack>
          <Typography color="textSecondary" fontSize={13}>
            Copyright &copy; {new Date().getFullYear()} Don&lsquo;t Panic.
          </Typography>
        </Stack>
        <Typography color="textSecondary" fontSize={13}>
          Made with ❤️ by <Link href="https://peterprototypes.com" taget="_blank">Peter Todorov</Link>
        </Typography>
      </Stack>
    </Container>
  </Box >
);

export default Footer;